import { Grid } from '@mui/material';
import React from 'react';
import { DashboardCard } from '../DashboardCard/DashboardCard';
import { ICommonClient, getClientsPaginated } from '../../services/client.service';
import { toast } from 'react-toastify';
import { ClientStatus } from '../../utils/clientStatus';
import { useNavigate } from 'react-router-dom';
import { UserRolesEnum } from '../../utils/rolesEnum';
import { adminTypeEnum } from '../../utils/adminTypes';

interface IClientsPendingEnrollmentDashboardCardProps {
  userRole: string;
  adminType: string;
}

export default function ClientsPendingEnrollmentDashboardCard(props: IClientsPendingEnrollmentDashboardCardProps) {
  const { adminType, userRole } = props;
  const navigate = useNavigate();

  const [clients, setClients] = React.useState<ICommonClient[]>([]);
  const [lastDoc, setLastDoc] = React.useState<any>(null);
  const [hasMore, setHasMore] = React.useState(true);
  const [isInitialLoading, setIsInitialLoading] = React.useState(true);
  const [isPaginating, setIsPaginating] = React.useState(false);

  const checkCardPermission =
    userRole === UserRolesEnum.NAVIGATOR ||
    userRole === UserRolesEnum.SUPER_ADMIN ||
    (userRole === UserRolesEnum.ADMIN && adminType !== adminTypeEnum.EMPLOYMENT);

  const loadMoreClients = async (isFirstLoad = false) => {
    if (!hasMore) return;

    if (isFirstLoad) setIsInitialLoading(true);
    else setIsPaginating(true);

    try {
      const { clients: newClients, lastDoc: newLastDoc } = await getClientsPaginated(
        ClientStatus.PENDING_ENROLLMENT,
        10,
        lastDoc
      );

      setClients((prev) => [...prev, ...newClients]);
      setLastDoc(newLastDoc);
      if (!newLastDoc || newClients.length < 10) setHasMore(false);
    } catch (err: any) {
      toast.error('Unable to load client list');
    } finally {
      if (isFirstLoad) setIsInitialLoading(false);
      else setIsPaginating(false);
    }
  };

  React.useEffect(() => {
    if (checkCardPermission) loadMoreClients(true);
    // eslint-disable-next-line
  }, [userRole]);

  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore) {
      loadMoreClients();
    }
  };

  return checkCardPermission ? (
    <Grid item lg={6} xs={12}>
      <DashboardCard
        isLoading={isInitialLoading}
        label='New Clients Pending Enrollment'
        desc='List of upcoming clients awaiting enrollment'
        list={clients}
        onItemClick={(item: any) => {
          navigate('../clientInfo', { state: { clientId: item.id } });
        }}
        onScroll={handleScroll}
        height='376px'
        showBottomLoader={isPaginating}
      />
    </Grid>
  ) : null;
}
